<template>
  <Main>
    <BackButton text="Back to Project" :route="$routes.project(project.id)" />

    <v-container style="max-width: 90%">
      <v-row>
        <v-col>
          <h1>
            {{ project.name }} - PSIs
          </h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
              :headers="tableFieldPsis"
              :items="psis"
              item-key="id"
              :items-per-page="10"
              :hide-default-footer="psis.length <= 10"
              class="elevation-3"
          >
            <template v-slot:item.name="{ item }">
              <b>{{ item.name }}</b> <v-chip v-if="item.relative_margins" size="small">Relative Margins</v-chip>
            </template>

            <template v-slot:item.action="{ item }">

              <!-- EDIT BUTTON -->
              <v-tooltip :text="`Edit PSI '${item.name}'`" location="top">
                <template v-slot:activator="{ props }">
                  <v-btn
                      v-bind="props"
                      class="mr-5 border-md"
                      size="small"
                      rounded
                      flat
                      height="35px"
                      min-width="35px"
                      max-width="35px"
                      @click.prevent="onEditPsi(item.id)"
                      @auxclick.prevent="onMiddleClickEditPsi(item.id)"
                  ><i class="fas fa-pen text-blue-darken-4" /></v-btn>
                </template>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="auto">
          <OverviewUpdateValues method="psi" :project-id="project.id" :errors="errors"></OverviewUpdateValues>
        </v-col>
      </v-row>
    </v-container>
  </Main>

</template>

<script setup>
import Main from "../../Layouts/Main.vue";
import {router} from "@inertiajs/vue3";
import * as $routes from "@/packs/routes";
import StringManipulation from "@/Mixins/StringManipulation";
import {computed} from "vue";
import OverviewUpdateValues from "@/Pages/Projects/subcomponents/OverviewUpdateValues.vue";
import BackButton from "@/Shared/BackButton.vue";

const props = defineProps({
  project: {
    type: Object,
    required: true
  },

  psisList: {
    type: Array,
    required: true
  },

  aggregationLevels: {
    type: Array,
    required: true
  },

  aggregationLevelValues: {
    type: Array,
    required: true
  },

  errors: {
    type: Array,
    required: true
  },

});

const tableFieldPsis = [
  { key: 'id', title: 'ID' },
  { key: 'name', title: 'Name' },
  { key: 'value', title: 'Value' },
  { key: 'target_value', title: 'Target Value' },
  { key: 'call_impact', title: 'Call Impact' },
  { key: "action", title: "Actions", align: "center"}
]

const psis = computed(() => {
  return props.psisList.map((psi) => {

    return {
      ...psi,
      name: StringManipulation.methods.clearAndCapitalize(psi.name),
      value: parseFloat(psi.value).toLocaleString('en-US'),
      target_value: parseFloat(psi.target_value).toLocaleString('en-US')
    }
  });
});

function onEditPsi(id) {
  router.get($routes.edit_project_psi(props.project.id, id));
}

function onMiddleClickEditPsi(id) {
  const route = $routes.edit_project_psi(props.project.id, id);
  window.open(route, '_blank');
}
</script>

<style scoped>

</style>
